var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPremiumTheme(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_385_25090)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3705 6.00201C15.3729 6.04603 15.3697 6.09083 15.3586 6.13533L14.3717 10.083C14.3219 10.2819 14.1437 10.4217 13.9388 10.4228L8.01729 10.4527C8.01651 10.4527 8.01579 10.4527 8.01501 10.4527H2.09346C1.88746 10.4527 1.70796 10.3124 1.6582 10.1125L0.671282 6.14987C0.659918 6.10417 0.656628 6.05811 0.659499 6.01296C0.277712 5.89267 0 5.53541 0 5.11438C0 4.59491 0.422579 4.17233 0.942056 4.17233C1.46153 4.17233 1.88411 4.59491 1.88411 5.11438C1.88411 5.40693 1.75007 5.66867 1.54019 5.84159L2.77581 7.08654C3.08809 7.40122 3.52144 7.58161 3.96477 7.58161C4.48897 7.58161 4.98877 7.33267 5.30351 6.91559L7.33416 4.22496C7.16357 4.0545 7.05794 3.81895 7.05794 3.55924C7.05794 3.03977 7.48052 2.61719 8 2.61719C8.51948 2.61719 8.94206 3.03977 8.94206 3.55924C8.94206 3.81118 8.84205 4.03984 8.68037 4.20905C8.68091 4.20977 8.68157 4.21037 8.68211 4.21115L10.698 6.90919C11.0127 7.33028 11.5143 7.58167 12.04 7.58167C12.4874 7.58167 12.9081 7.40744 13.2244 7.09103L14.4678 5.84763C14.2535 5.67477 14.1159 5.41052 14.1159 5.11438C14.1159 4.59491 14.5385 4.17233 15.0579 4.17233C15.5774 4.17233 16 4.59491 16 5.11438C16 5.52416 15.7365 5.87269 15.3705 6.00201ZM14.2754 11.8583C14.2754 11.6106 14.0746 11.4097 13.8268 11.4097H2.22307C1.97533 11.4097 1.77447 11.6106 1.77447 11.8583V12.9349C1.77447 13.1827 1.97533 13.3835 2.22307 13.3835H13.8268C14.0746 13.3835 14.2754 13.1827 14.2754 12.9349V11.8583Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_385_25090"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremiumTheme);
export default __webpack_public_path__ + "static/media/premium-theme.67abadb0d1daef4092d0f76024deb8c7.svg";
export { ForwardRef as ReactComponent };